import { Box } from '@mui/material';
import { SocialNetwork, UserEntity } from '@okletsplay/core';
import React, { FC } from 'react';
import { SocialNetworkLink } from './SocialNetworkLink';
import { useStyles } from './SocialNetworkLinksList.styles';

interface SocialLinksListProps {
  links: UserEntity['socialNetworkLinks'];
}

export const SocialNetworkLinksList: FC<SocialLinksListProps> = ({ links = {} }) => {
  const { classes } = useStyles();

  const linksList = Object.entries(links)
    .sort(([network1], [network2]) => network1.localeCompare(network2))
    .map(([network, link]) => (
      <Box key={network} className={classes.item}>
        <SocialNetworkLink network={network as SocialNetwork} link={link as string} />
      </Box>
    ));

  return <Box className={classes.root}>{linksList}</Box>;
};
